// Published major.minor versions are decimal values: 1.02 < 1.1 == 1.10.
export function compareAppVersion(left, right) {
  const parse = value => {
    if (typeof value !== 'string') return null
    const text = value.trim().replace(/^[Vv]/, '')
    if (!/^[0-9]+(?:\.[0-9]+)*(?:-[A-Za-z0-9][A-Za-z0-9.-]*)?$/.test(text)) return null
    const parts = text.split('-')[0].split('.')
    return parts.every(part => Number(part) <= 2147483647) ? parts : null
  }
  const a = parse(left); const b = parse(right)
  if (!a || !b) return NaN // Unknown versions must not satisfy a feature threshold.
  const major = Number(a[0]) - Number(b[0])
  if (major) return Math.sign(major)
  const af = a[1] || '0'; const bf = b[1] || '0'
  const width = Math.max(af.length, bf.length)
  const x = af.padEnd(width, '0'); const y = bf.padEnd(width, '0')
  if (x !== y) return x > y ? 1 : -1
  for (let i = 2; i < Math.max(a.length, b.length); i++) {
    const patch = Number(a[i] || 0) - Number(b[i] || 0)
    if (patch) return Math.sign(patch)
  }
  return 0
}
